import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./Login.scss";
import { LoginIcon } from "../Icons.jsx";

import { login } from "../../actions/session";
import { Link } from "react-router-dom";

const LoginPage = (props) => {
	const [values, setValues] = useState({});
	const [errors] = useState({});
	const dispatch = useDispatch();

	const { error, isAuthenticated, adminInfo } = useSelector(
		(state) => state.login,
	);
	const handleChange = (e) => {
		const { name, value } = e.target;
		setValues({
			...values,
			[name]: value,
		});
	};

	const handleSubmit = (event) => {
		event.preventDefault();
		dispatch(login(values.email, values.password));
	};

	useEffect(() => {
		if (isAuthenticated) {
			adminInfo.role !== "shipper"
				? props.history.push("/notifications")
				: props.history.push("/shipping-labels");
		}
	}, [isAuthenticated]);

	return (
		<div className="form-page-container login-page">
			<div className="form-page-box">
				<div className="form-page-header">
					<h2 className="form-page-header-title">Log In</h2>
					<div className="error-container">
						{error && <div className="error-message">{error}</div>}
					</div>
				</div>
				<div className="form-page-content">
					<form className="form" onSubmit={handleSubmit} noValidate>
						<div className="form-container">
							<div className="input-group">
								<label htmlFor="email">Email</label>
								<div className="input-field">
									<input
										type="email"
										name="email"
										id="email"
										value={values.email || ""}
										onChange={handleChange}
										className={`${errors.email && "inputError"}`}
									/>
									{errors.email && (
										<p className="error-input">{errors.email}</p>
									)}
								</div>
							</div>
							<div className="input-group">
								<label htmlFor="password">Password</label>
								<div className="input-field">
									<input
										type="password"
										name="password"
										id="password"
										value={values.password || ""}
										onChange={handleChange}
										className={`input-field ${errors.email && "inputError"}`}
									/>
									{errors.pw && <p className="error-input">{errors.pw}</p>}
								</div>
							</div>
							<div className="forgot-password-link">
								<Link to="/forgot-password">Forgot Password?</Link>
							</div>
							<div className="form-actions">
								<button type="submit" className="btn btn-primary">
									Log In
									<LoginIcon />
								</button>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	);
};

export default LoginPage;
